<template>
  <KfDesktop>
    <template #wallpaper>
      <div></div>
    </template>
    <template #appGrid>
      <div class="grid-box">
        <div class="logo-div">
          <img src="/logo/jetpost.png" class="logo-image"/>
        </div>
        <div class="app-div">
          <MyAppGrid/>
        </div>
      </div>
    </template>
  </KfDesktop>
</template>
<script>
import MyAppGrid from "@/views/MyAppGrid.vue";

export default {
  name: 'Desktop',
  components: {MyAppGrid}
};
</script>

<style lang="less" scoped>
.grid-box {
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .logo-div {
    text-align: center;
    flex: 1;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 40px;
  }

  .logo-image {
    height: 200px;
  }

  .app-div {
    flex: 2;
  }

}
</style>
